import React from "react"

import FormError from "../../../../../gd-form/common/form-error/form-error"
import Form from '../../../../../gd-form/form/deprecated/form-add/form-add'
import FormManager from "../../../../../gd-form/common/form-manager"
import FieldsFactory from "../../../../../fields3/fields-factory"
import {FieldType} from "../../../../../fields3/field-type"
import FieldFormElement from "../../../../../fields3/render/form-elemnent"
import {myTeamDashboardConfig} from "./create-config"
import {createCustomDashboardWithSetup} from "../../../../../../app/quick-add/sections/dashboard/actions/create-custom-dashboard-with-setup"

type Props = {
    initParams: any
}

export default function MyTeamDashboardSetup(props: Props) {
    console.log("MyTeamDashboardSetup props=", props)

    const onSubmit = (formData:any) => {

        const config = myTeamDashboardConfig(formData.userIds)
        createCustomDashboardWithSetup(formData.name, config, props.initParams)
    }

    const fieldUsers = FieldsFactory.get({
        fieldId         : 'userIds',
        type            : FieldType.USERS,
        isRequired      : true,
        noValueOption   : false,
        // accessLevels    : [ConstProject.access.FULL]
    })
    const fieldName = FieldsFactory.get({
        fieldId         : 'name',
        type            : FieldType.STRING,
        isRequired      : true
    })

    let companyUserIds : ID[] = gd.session.companyUsers.exportToArrayUserId()

    const initFormData = {
        name        : 'My Team',
        userIds     : companyUserIds.slice(0,5)
    };
    const formStructure = {
        fields: {
            name        : { type: 'input', isRequired: true},
            userIds     : { type: 'select', isRequired: true}
        },
        onSubmit: onSubmit
    };
    const form = new FormManager(formStructure,initFormData);

    return (
        <Form form={form} submitBtnClass="grey">
            <div className="tbl">
                <div className="row planning">
                    <div className="label">Name:</div>
                    <div className="element">
                        <FieldFormElement field={fieldName} form={form} />
                        <FormError form={form} name="name" />
                    </div>
                </div>
                <div className="row planning">
                    <div className="label">Select users:</div>
                    <div className="element">
                        <FieldFormElement field={fieldUsers} form={form} />
                        <FormError form={form} name="userIds" />
                    </div>
                </div>

            </div>
        </Form>
    )

}
